/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerDeleteTopUpsMutationResponse,
  TelegramProductsModeratorControllerDeleteTopUpsPathParams,
  TelegramProductsModeratorControllerDeleteTopUps401,
} from '../../types/TelegramProductsModeratorControllerDeleteTopUps.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsModeratorDeleteTopUps } from '../../methods/telegramProductsModeratorDeleteTopUps.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsModeratorDeleteTopUpsMutationKey = () =>
  [{ url: '/api/moderator/telegram/products/top-ups/:id' }] as const;

export type TelegramProductsModeratorDeleteTopUpsMutationKey = ReturnType<
  typeof telegramProductsModeratorDeleteTopUpsMutationKey
>;

/**
 * {@link /api/moderator/telegram/products/top-ups/:id}
 */
export function useTelegramProductsModeratorDeleteTopUps<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsModeratorControllerDeleteTopUpsMutationResponse,
      ResponseErrorConfig<TelegramProductsModeratorControllerDeleteTopUps401>,
      { id: TelegramProductsModeratorControllerDeleteTopUpsPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsModeratorDeleteTopUpsMutationKey();

  return useMutation<
    TelegramProductsModeratorControllerDeleteTopUpsMutationResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerDeleteTopUps401>,
    { id: TelegramProductsModeratorControllerDeleteTopUpsPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return telegramProductsModeratorDeleteTopUps(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
